<template>
  <PbBasicView
    class="pb-error"
    :show-header="showHeader"
  >
    <h1 class="pb-error-title">
      {{ title }}
    </h1>
    <MessageBox
      color="error"
    >
      {{ message }}
    </MessageBox>
    <slot />
    <AccessRequestForm
      v-if="status === SDKTypes.HttpStatusCode.FORBIDDEN && meta.requestPermission"
      :read="meta.requestPermission.read"
      :write="meta.requestPermission.write"
      :delete="meta.requestPermission.delete"
      :copy="meta.requestPermission.copy"
    />
    <FlexBox direction="row">
      <ControlButton
        to="/"
        :label="translationsLoaded ? translate('generic.home') : 'Home'"
        :onclick="clearErrors"
      />
      <ControlButton
        :label="translationsLoaded ? translate('generic.refresh') : 'Refresh'"
        @click="reload"
      />
    </FlexBox>
  </PbBasicView>

  <!--
  <div class="pb-error">
    <h3>Error page: {{ title }}</h3>
    <p>{{ msg }}</p>
    <div class="pb-view">
      <div class="pb-content">
        <div class="pb-fullpage">
          <div class="pb-home-content">
            <home-menu  :hideNew="true" :showHome="true"></home-menu>

            <div v-if="isForbidden" class="content-right">
              <h1>{{ $t('generic.unauthorizedAccess') }}</h1>
              <div class="pb-panel-wrapper">
                <div v-if="pending" class="pb-panel-line">
                  <div class="panel-section">
                    <h2 class="txt-success" >{{ $t('demand.reviewingMsg') }}</h2>
                  </div>
                </div>
                <div v-else class="pb-panel-line">
                  <div class="panel-section">
                    <h2 class="txt-info">{{ $t('demand.unauthorizedAccessMsg') }}</h2>
                  </div>
                  <div class="panel-section">
                    <h2>{{ $t('demand.requestAccessMsg') }}</h2>
                  </div>
                  <div class="panel-section">
                    <control-switch
                      :label="$t('generic.read')"
                      v-model="read"
                      readOnly
                      :title="$t('demands.ask.read')"
                      :data-tooltip="$t('demands.ask.read')"
                    />
                  </div>
                  <div class="panel-section">
                    <control-switch
                      :label="$t('generic.write')"
                      v-model="write"
                      :title="$t('demands.ask.readWrite')"
                      :data-tooltip="$t('demands.ask.readWrite')"
                    />
                  </div>
                  <div class="panel-section">
                    <button class="btn btn-success" @click="makeDemand">
                      {{ $t('demand.requestAccess') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="content-right">
              <h1>{{title}}</h1>
              <div v-show="msg" class="msg msg-error">
                <p v-for="(error,key) in errors" :key="key">{{error.code}} : {{error.text}}</p>
                <h3>{{ msg }}</h3>
              </div>
            </div>

          </div>
        </div>
      </div>
  </div>
  -->
</template>

<script setup>
/*
IMPORTANT NOTE:
The "Home" button has the "click" event handler defined as a prop instead of event.
```
:onclick="clearErrors"
```
This is because the "ControlButton" component is made to be compatible with vue2,
so the events are passed in the "$listeners" object and it causes issues since
we're using vue3 here.

When all projects use vue3, we can disable the compat layer for "INSTANCE_LISTENERS"
and change the ControlButton component to only use the "$attrs" object.
*/

import ControlButton from '@nicolaudie-group/ng-ui-kit/components/ControlButton/ControlButton.vue'
import MessageBox from '@nicolaudie-group/ng-ui-kit/components/MessageBox/MessageBox.vue'
import FlexBox from '@nicolaudie-group/ng-ui-kit/components/FlexBox/FlexBox.vue'

import AccessRequestForm from '@/components/AccessRequestForm/AccessRequestForm.vue'
import PbBasicView from '@/components/PbBasicView.vue'
import useTranslate from '@/composables/useTranslate'
import { SDKTypes } from '@/helpers/sdk'
import useRootStore from '@/stores/root.store'

defineProps({
  showHeader: { type: Boolean, default: false },
  title: { type: String, default: 'Not found' },
  message: { type: String, default: 'This ressource was not found' },
  status: { type: Number, default: null },
  meta: { type: Object, default: () => ({}) },
})

const { translate, translationsLoaded } = useTranslate()

const rootStore = useRootStore()

function clearErrors() {
  rootStore.clearErrorPages()
}

function reload() {
  window.location.reload()
}
</script>

<script>
export default {
  name: 'ErrorView',
}
</script>

<style lang="scss">
@use 'sass:math';
@use '@nicolaudie-group/ng-ui-kit/defines/_fonts.define.scss';
@use '@nicolaudie-group/ng-ui-kit/defines/_colors.define.scss';
@use '@nicolaudie-group/ng-ui-kit/defines/_config.define.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_flexbox.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_generic.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_responsive.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_theme.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_animations.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_transitions.mixin.scss';

@use '/src/styles/_pb.scss';

.pb-error {
  .pb-error-title {
    text-align: center;
    margin-bottom: pb.$spacing;
  }
}
</style>
